module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/images/tile_holiday-676a0c4427d96abf7e5b6389b8a6cb17.jpg";